import { defineMessage, useIntl } from 'react-intl';
import {
  type GlycerinButtonClickPayload,
  type GlycerinFormSubmitClickPayload,
} from '@packages/tracking/src/types/payloads';
import { cn } from '@packages/shared/src/utils/cn/cn';
import { Button, type ButtonProps } from '@packages/shared/src/ui/Button/Button';
import { useButtonClickTracking } from '@packages/shared/src/ui/Button/useButtonClickTracking';

export type LoginButtonProps = ButtonProps & {
  clickTrackingProps?:
    Omit<GlycerinButtonClickPayload, 'label'> | Omit<GlycerinFormSubmitClickPayload, 'label'>;
};

const loginLabel = defineMessage({
  id: 'slot.account.login',
  defaultMessage: 'Anmelden',
});

export const LoginButton = ({ clickTrackingProps, onClick, ...props }: LoginButtonProps) => {
  const { dispatchButtonClickTracking } = useButtonClickTracking();

  const { formatMessage } = useIntl();
  const { type } = props;
  const { category, detail } = clickTrackingProps ?? {};

  return (
    <Button
      onClick={(event) => {
        dispatchButtonClickTracking(
          {
            ...clickTrackingProps,
            category: category ?? (type === 'submit' ? 'form-submit-click' : 'button-click'),
            detail: detail ?? 'Login Button click',
            label: formatMessage(loginLabel),
          },
          type,
        );
        if (onClick) {
          onClick(event);
        }
      }}
      {...props}
      color="primary"
      className={cn('focus-within:standard-focus-outline', props.className)}
    >
      {formatMessage(loginLabel)}
      <span className="icon-emp-arrow-large-right size-4" />
    </Button>
  );
};
